import { GameObj } from 'kaplay';
import { Colors } from '../constants/colors';
import { GAME_HEIGHT, GAME_WIDTH } from '../constants/constants';
import { Scenes } from '../constants/scenes';
import { crowdMusic } from '../main';
import { GameState } from '../types/game-state';

/**
 * Game over cutscene where the player and child circle orbit each other (a dance).
 * No user controls are active here.
 */
export function gameOverScene() {
  scene(Scenes.GAME_OVER, (gameState: GameState) => {
    debug.log('in game over scene');

    const playerColorTuple = Colors[gameState.playerColor] as [number, number, number];
    const sharedColor = rgb(...playerColorTuple);

    // Title text
    add([
      text('Reunited!', { font: 'arial', size: 64, width: 800, align: 'center' }),
      color(...Colors.BLACK),
      pos(GAME_WIDTH / 2, 90),
      anchor('center'),
    ]);

    // Sub text
    add([
      text('Click on a circle to play again', {
        font: 'arial',
        size: 32,
        width: 600,
        align: 'center',
      }),
      color(...Colors.BLACK),
      pos(GAME_WIDTH / 2, 160),
      anchor('center'),
    ]);

    // Center point for the dance
    const center = vec2(GAME_WIDTH / 2, GAME_HEIGHT / 2 + 40);
    setCamPos(center); // keep camera fixed on the center

    // Player circle visual (larger) - custom draw replicates normal style without controls
    const playerCircle = add([
      pos(center.x + 90, center.y),
      area(),
      circle(32),
      'game-over-circle',
      {
        draw(this: GameObj) {
          drawCircle({ color: rgb(...(Colors.BLACK as [number, number, number])), radius: 32 });
          drawCircle({ color: sharedColor, radius: 30 });
        },
      },
    ]);

    // Child circle (smaller)
    const childCircle = add([
      pos(center.x - 90, center.y),
      area(),
      circle(20),
      'game-over-circle',
      {
        draw(this: GameObj) {
          drawCircle({ color: rgb(...(Colors.BLACK as [number, number, number])), radius: 20 });
          drawCircle({ color: sharedColor, radius: 18 });
        },
      },
    ]);

    let angle = 0; // radians
    const orbitRadius = 90;
    const angularSpeed = 1; // radians / second

    // Driver entity updates positions each frame
    add([
      {
        update() {
          angle += angularSpeed * dt();
          const playerAngle = angle;
          const childAngle = angle + Math.PI; // opposite side
          playerCircle.pos = center.add(
            vec2(Math.cos(playerAngle) * orbitRadius, Math.sin(playerAngle) * orbitRadius),
          );
          childCircle.pos = center.add(
            vec2(Math.cos(childAngle) * orbitRadius, Math.sin(childAngle) * orbitRadius),
          );
        },
      },
    ]);

    // Allow player to click either circle to return to the crowd scene.
    onClick('game-over-circle', () => {
      // Return to the crowd scene using the same game state (no mutation).
      crowdMusic.play();
      go(Scenes.CROWD, gameState);
    });
  });
}
